import Typography from "@mui/material/Typography";
import * as React from "react";
import {observer} from "mobx-react";

function LayoutContentTitle({title}) {
    const style = styles();
    return (
        <Typography variant="h2" component="div" sx={style.title}>{title}</Typography>
    );
}

export default observer(LayoutContentTitle);

const styles = () => ({
    title: {
        fontSize: '1.5em'
    },
});